import { Component, OnInit, Input, Output, EventEmitter } from '@angular/core';
import { SJT } from 'src/app/shared/models/exercise.model';
// import { SJT } from 'src/app/models/exercise.model';
// import { UtilityService } from 'src/app/services/utility.service';

@Component({
  selector: 'app-sjt',
  templateUrl: './sjt.component.html',
  styleUrls: ['./sjt.component.css']
})
export class SjtComponent implements OnInit {

  @Input() index: any;
  @Input() exerciseTimetrackingdata;
  _element: SJT;
  _answer: string;
  radioSelected: string;
  radioSelectedLeast: string;
  @Input() id: string;
  @Input() points: any;
  @Input() exerciseId: any;
  @Input() variableFeedback: any;
  @Input() userFeedback;
  @Output() reportFeedback = new EventEmitter<Object>();
  @Output() likeDislike = new EventEmitter<boolean>();
  @Input() isSubmitted: boolean = false;
  @Input() isResultPublished: boolean = false;
  @Input() immediateFeedBackRequired: boolean = false;
  @Input() showBackButton: boolean = false;
  @Input() fixedEditor: any;
  visible: boolean = true;
  section: any = [];
  selectedOption: any = [];
  selectedText: string;
  secondSelectedText: string;

  questionChecked: boolean = false;
  @Input() set element(element) {
    this._element = element;
  }
  @Input() set answer(answer) {
    this._answer = answer;
    if(this._answer){
      this.questionChecked = true;
      this.radioSelected = this._answer.split(',')[0];
      this.radioSelectedLeast = this._answer.split(',')[1];
      console.log(this.radioSelected + ',' + this.radioSelectedLeast);
      if(this.radioSelected && this.radioSelectedLeast){
        let selectedText = this._element.options.find((option) => {
          return this.radioSelected == option._id;
          })
          console.log(this.selectedText);
          this.selectedText = selectedText.text;
          let selectedTextLeast = this._element.optionsLeast.find((option) => {
           return option._id == this.radioSelectedLeast;
          })
          console.log(selectedTextLeast);
          this.secondSelectedText = selectedTextLeast.text;
      }
    }
  }

  @Output() onValueChange = new EventEmitter<Object>();
  @Output() onReview = new EventEmitter<Object>();
  @Output() back = new EventEmitter<Boolean>(false);
  @Input() questionBlos;


  constructor() { }

  ngOnInit() {
    console.log(this.isSubmitted);
  }

  backHandler() {
    this.back.emit(true);
  }

  next(event, event2) {

    this.onValueChange.emit({ elementId: this.id, answer: event.concat(",", event2) });
  }
  check() {
    this.questionChecked = true;
    this.onReview.emit({ elementId: this.id, answer: this.radioSelected + ',' + this.radioSelectedLeast });
  }
  skip() {
    this.onValueChange.emit({ elementId: this.id, answer: '' });
  }
  _reportFeedback(value) {
    this.reportFeedback.emit(value);
  }

  _likeDislike(like) {
    this.likeDislike.emit(like);
  }

  getText(text) {
    this.selectedText = text;
    this.section['second'] = true;
    // let selectedOption = this._element.options.filter((option) => {
    //   option._id == id;
    // })
    // return selectedOption[0]['text'];

  }

  getSecondText(text) {
    this.secondSelectedText = text;
    // let selectedOption = this._element.options.filter((option) => {
    //   option._id == id;
    // })
    // return selectedOption[0]['text'];

  }

}
